// Public metrics only. Missing metrics never contribute a fabricated zero.
export const metricValue = (post, metric) => {
  const valid = (value) => typeof value === 'number' && Number.isFinite(value) && value >= 0;
  if (metric === 'engagement') return valid(post.likes) && valid(post.comments) ? post.likes + post.comments : null;
  return valid(post[metric]) ? post[metric] : null;
};

export const averageMetric = (posts, metric) => {
  const values = posts.map((post) => metricValue(post, metric)).filter((value) => value != null);
  return { value: values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null, count: values.length };
};

export const contentType = (post) => {
  switch ((post.type || '').toLowerCase()) {
    case 'video': case 'reel': case 'reels': return 'video';
    case 'image': return 'image';
    case 'carousel_album': case 'carousel': return 'carousel';
    case 'text': return 'text';
    case 'link': return 'link';
    default: return 'unknown';
  }
};

export const frequency = (snapshot, days, now = Date.now()) => {
  if (!snapshot) return null;
  const cutoff = now - days * 86400000;
  return (snapshot.posts || []).filter((post) => {
    const date = Date.parse(post.published);
    return Number.isFinite(date) && date >= cutoff && date <= now;
  }).length;
};

export const groupMetrics = (posts, keys, group, metric) => keys.map((key) => {
  const matching = posts.filter((post) => group(post) === key);
  return { key, total: matching.length, ...averageMetric(matching, metric) };
});

export const rankPosts = (posts, metric) => [...posts].sort((a, b) => {
  const dateDifference = Date.parse(b.published) - Date.parse(a.published);
  if (metric === 'latest') return dateDifference;
  const left = metricValue(a, metric); const right = metricValue(b, metric);
  if (left == null && right == null) return dateDifference;
  if (left == null) return 1;
  if (right == null) return -1;
  return right - left || dateDifference;
});
